export const APPLICATION_STATUS = {
  BORROWER_CHANGES_REQUIRED: 'BORROWER_CHANGES_REQUIRED',
  INPROGRESS: 'INPROGRESS',
  CREATED: 'CREATED',
  AUTOMATED_REVIEW_INPROGRESS: 'AUTOMATED_REVIEW_INPROGRESS',
  TECHNICAL_REVIEW: 'TECHNICAL_REVIEW',
  AUTOMATED_REVIEW_APPROVED: 'AUTOMATED_REVIEW_APPROVED',
  AUTOMATED_REVIEW_DECLINED: 'AUTOMATED_REVIEW_DECLINED',
  MANUAL_REVIEW_INPROGRESS: 'MANUAL_REVIEW_INPROGRESS',
  MANUAL_REVIEW_APPROVED: 'MANUAL_REVIEW_APPROVED',
  MANUAL_REVIEW_DECLINED: 'MANUAL_REVIEW_DECLINED',
  MANUAL_REVIEW_DOCS_REQUIRED: 'MANUAL_REVIEW_DOCS_REQUIRED',
  AUTOMATED_REVIEW_ADDITIONAL_DOCS_REQUIRED: 'AUTOMATED_REVIEW_ADDITIONAL_DOCS_REQUIRED',
  AUTOMATED_REVIEW_DOCS_REQUIRED: 'AUTOMATED_REVIEW_DOCS_REQUIRED',
  PENDING_SELECTION_DOCS_REQUIRED: 'PENDING_SELECTION_DOCS_REQUIRED',
  MANUAL_REVIEW_DOCS_REQUIRED_SALES: 'MANUAL_REVIEW_DOCS_REQUIRED_SALES',
  MANUAL_REVIEW_REQUIRED: 'MANUAL_REVIEW_REQUIRED',
  MANUAL_REVIEW_REQUIRED_SALES: 'MANUAL_REVIEW_REQUIRED_SALES',
  MANUAL_REVIEW_REQUIRED_DEPOSIT_VERIFICATION: 'MANUAL_REVIEW_REQUIRED_DEPOSIT_VERIFICATION',
  SUSPENSE: 'SUSPENSE',
  AWAITING_ADDITIONAL_SYSTEM_DATA: 'AWAITING_ADDITIONAL_SYSTEM_DATA',
  PENDING_SELECTION: 'PENDING_SELECTION',
  BORROWER_AGREEMENT_ACCEPTED: 'BORROWER_AGREEMENT_ACCEPTED',
  MANUAL_REVIEW_APPROVED_WAITLISTED: 'MANUAL_REVIEW_APPROVED_WAITLISTED',
  DENIED: 'DENIED',
  CLOSED: 'CLOSED',
};
export const PARTNER_STATUS = {
  PARTNER_VERIFICATION_REQUIRED: 'PARTNER_VERIFICATION_REQUIRED',
  PARTNER_VERIFICATION_FAILED: 'PARTNER_VERIFICATION_FAILED',
  PARTNER_VERIFICATION_COMPLETED: 'PARTNER_VERIFICATION_COMPLETED',
  PARTNER_VERIFICATION_NOT_APPLICABLE: 'PARTNER_VERIFICATION_NOT_APPLICABLE',
};

export const isApplicationWIP = (appStatus) => {
  if (
    appStatus === APPLICATION_STATUS.BORROWER_CHANGES_REQUIRED ||
    appStatus === APPLICATION_STATUS.INPROGRESS ||
    appStatus === APPLICATION_STATUS.CREATED ||
    appStatus === APPLICATION_STATUS.AWAITING_ADDITIONAL_SYSTEM_DATA
  ) {
    return true;
  } else {
    return false;
  }
};

export const doesApplicationHaveWIPSections = (app) => {
  if (!app?.applicationFeatures) return false;
  const wipFeatures = app.applicationFeatures.filter((feature) => {
    return (
      feature.phase === app.phase &&
      app.sectionSequence.includes(feature.section) &&
      (feature.itemType !== 'FileProperty' ||
        (feature.itemType === 'FileProperty' &&
          feature.value.filter(
            (file) =>
              (file.status === 'REQUESTED' || file.status === 'DECLINED') &&
              !file.fileType.includes('bankVerificationStatement')
          ).length > 0))
    );
  });
  return wipFeatures.length && wipFeatures.length > 0;
};
